import { createSelector } from "reselect";

// Base selectors
const selectMinutesState = (state) => state.minutes;

// Memoized selectors
export const minutesSelectors = {
  selectAllMinutes: createSelector(
    [selectMinutesState],
    (minutesState) => minutesState.minutes
  ),

  selectMinutesLoading: createSelector(
    [selectMinutesState],
    (minutesState) => minutesState.loading
  ),

  selectMinutesError: createSelector(
    [selectMinutesState],
    (minutesState) => minutesState.error
  ),

  selectMinute: createSelector(
    [selectMinutesState],
    (minutesState) => minutesState.minute
  ),
  selectSelectedMinute: createSelector(
    [selectMinutesState],
    (minutesState) => minutesState.selectedMinute
  ),
  selectMinuteLoading: createSelector(
    [selectMinutesState],
    (minutesState) => minutesState.loading
  ),

  selectMinutesFilter: createSelector(
    [selectMinutesState],
    (minutesState) => minutesState.filter
  ),

  selectIsCreating: createSelector(
    [selectMinutesState],
    (minutesState) => minutesState.creating
  ),

  selectIsUpdating: createSelector(
    [selectMinutesState],
    (minutesState) => minutesState.updating
  ),

  selectIsDeleting: createSelector(
    [selectMinutesState],
    (minutesState) => minutesState.deleting
  ),

  // Computed selectors
  selectFilteredMinutes: createSelector(
    [selectMinutesState],
    (minutesState) => {
      const { minutes, filter } = minutesState;

      switch (filter) {
        case "recent":
          return minutes.filter((minute) => {
            const weekAgo = Date.now() - 7 * 24 * 60 * 60 * 1000;
            return new Date(minute.createdAt).getTime() > weekAgo;
          });
        case "archived":
          return minutes.filter((minute) => minute.archived);
        default:
          return minutes;
      }
    }
  ),

  selectMinuteById: (id) =>
    createSelector([selectMinutesState], (minutesState) =>
      minutesState.minutes.find((minute) => minute.id === id)
    ),

  selectIsAnyRequestPending: createSelector(
    [selectMinutesState],
    (minutesState) =>
      minutesState.loading ||
      minutesState.creating ||
      minutesState.updating ||
      minutesState.deleting
  ),
};
